export default {
  getErrors: state => {
    return state.errors;
  }
};
